import React from "react";
import styled from "styled-components";
import { divisionsT5 } from "../utils/constants";

const HallOfFamePageT5 = () => {
  return (
    <Canvas>
      <Content>
        <PageTitle>HALL OF FAME T5</PageTitle>
        <Grid>
          {divisionsT5.map((division) => (
            <Card key={`hof-t5-${division.id}`}>
              <DivisionName>{division.name}</DivisionName>

              {division.champion && (
                <Row $accent="gold">
                  <Icon
                    src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/champion_icon.png"
                    alt="Campeón"
                  />
                  <Label>CAMPEÓN</Label>
                  <Names>{division.champion}</Names>
                </Row>
              )}

              {division.promotions && (
                <Row $accent="mint">
                  <Icon
                    src={division.playoffPromotionIcon}
                    alt={division.playoffPromotionName}
                  />
                  <Label>{division.playoffPromotionName?.toUpperCase() || "ASCENSOS"}</Label>
                  <Names>{division.promotions.join(", ")}</Names>
                </Row>
              )}

              {division.relegations && (
                <Row $accent="uv">
                  <Icon
                    src={division.playoffRelegationIcon}
                    alt={division.playoffRelegationName}
                  />
                  <Label>{division.playoffRelegationName?.toUpperCase() || "DESCENSOS"}</Label>
                  <Names>{division.relegations.join(", ")}</Names>
                </Row>
              )}
            </Card>
          ))}
        </Grid>
      </Content>
    </Canvas>
  );
};

const Canvas = styled.div`
  background: var(--v-canvas);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 4rem 1.5rem;
`;

const Content = styled.div`
  width: 100%;
  max-width: 900px;
`;

const PageTitle = styled.h1`
  font-family: Anton, sans-serif;
  font-size: clamp(48px, 8vw, 72px);
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1;
  color: var(--v-fg);
  margin: 0 0 3rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 0.75rem;
`;

const Card = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DivisionName = styled.h3`
  font-family: var(--v-font-body);
  font-size: 16px;
  font-weight: 600;
  color: var(--v-fg);
  margin: 0 0 0.25rem;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  border: 1px solid
    ${({ $accent }) =>
      $accent === "gold"
        ? "rgba(201, 160, 78, 0.15)"
        : $accent === "mint"
        ? "rgba(60, 255, 208, 0.1)"
        : "rgba(82, 0, 255, 0.1)"};
`;

const Icon = styled.img`
  width: 1.6rem;
  height: 1.6rem;
  object-fit: contain;
  flex-shrink: 0;
`;

const Label = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  min-width: 4.5rem;
  flex-shrink: 0;
`;

const Names = styled.span`
  font-family: var(--v-font-body);
  font-size: 13px;
  font-weight: 600;
  color: var(--v-fg);
`;

export default HallOfFamePageT5;
